export default __webpack_public_path__ + "static/media/not_allowed.5cc59173.png";